<ham-modal
    [title]="title"
    size="xxl"
    [saveText]="exportPdfLabel"
    [showCancelButton]="true"
    [cancelText]="closeLabel"
    (save)="onExportPdf()"
    (cancel)="onClose()"
>
    <div *ngIf="sections.length === 0" class="reclass-preview-empty">
        {{ emptyLabel }}
    </div>

    <table *ngIf="sections.length > 0" class="reclass-preview-table">
        <thead>
            <tr>
                <th>{{ colFrom }}</th>
                <th>{{ colTo }}</th>
                <th class="text-right">{{ colCY }}</th>
                <th class="text-right">{{ colPY }}</th>
                <th>{{ colDescription }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let section of sections">
                <tr class="section-header-row">
                    <td colspan="5">{{ section.statementLabel }}</td>
                </tr>
                <tr *ngFor="let row of section.rows" class="data-row">
                    <td>{{ row.sourceLabel }}</td>
                    <td>{{ row.targetLabel }}</td>
                    <td class="text-right amount-cell">{{ formatAmt(row.cyAmount) }}</td>
                    <td class="text-right amount-cell">{{ formatAmt(row.pyAmount) }}</td>
                    <td class="description-cell">{{ row.description }}</td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</ham-modal>
